import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class StripeExternalAccountService {

  static async create({ propertyId, subpropertyId, externalAccountToken, defaultForCurrency }) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation STRIPEEXTERNALACCOUNT_CREATE(
          $propertyId: String!
          $subpropertyId: String!
          $externalAccountToken: String!
          $defaultForCurrency: Boolean
        ) {
          stripeExternalAccountCreate(
            propertyId: $propertyId,
            subpropertyId: $subpropertyId,
            externalAccountToken: $externalAccountToken,
            defaultForCurrency: $defaultForCurrency
          ) {
            id
          }
        }
      `,

      variables: {
        propertyId,
        subpropertyId,
        externalAccountToken,
        defaultForCurrency,
      },
    });

    return response.data.stripeExternalAccountCreate;
  }

  static async find(id, propertyId, connectedAccountId) {
    const response = await graphqlClient.query({
      query: gql`
        query STRIPEEXTERNALACCOUNT_FIND(
          $id: String!
          $propertyId: String!
          $connectedAccountId: String!
        ) {
          stripeExternalAccountFind(id: $id, propertyId: $propertyId, connectedAccountId: $connectedAccountId) {
            id
            type
            currency
            defaultForCurrency
            stripeExternalAccountId
            bankName
            routingNumber
            holderName
            holderType
            status
            last4
            country
            card {
              stripeCardId
              brand
              addressLine1Check
              addressPostalCodeCheck
              cvcCheck
              country
              expMonth
              expYear
              last4
              fingerprint
            }
            billingDetails {
              address {
                line1
                line2
                postalCode
                city
                state
                country
              }
              email
              name
              phone
            }
            availablePayoutMethods
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
        propertyId,
        connectedAccountId,
      },
    });

    return response.data.stripeExternalAccountFind;
  }

  static async list(propertyId, connectedAccountId, filter, limit, offset, orderBy) {
    const response = await graphqlClient.query({
      query: gql`
        query STRIPEEXTERNALACCOUNT_LIST(
          $propertyId: String!, 
          $connectedAccountId: String!,
          $filter: StripeExternalAccountFilterInput,
          $limit: Int,
          $offset: Int,
          $orderBy: StripeExternalAccountOrderByEnum
        ) {
          stripeExternalAccountList(
            propertyId: $propertyId
            connectedAccountId: $connectedAccountId
            filter: $filter
            limit: $limit
            offset: $offset
            orderBy: $orderBy
          ) {
            count
            rows {
              id
              type
              currency
              defaultForCurrency
              stripeExternalAccountId
              bankName
              routingNumber
              holderName
              holderType
              status
              last4
              country
              card {
                brand
                addressLine1Check
                addressPostalCodeCheck
                cvcCheck
                country
                expMonth
                expYear
                last4
                fingerprint
              }
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        propertyId,
        connectedAccountId,
        filter,
        limit,
        offset,
        orderBy,
      },
    });

    return response.data.stripeExternalAccountList;
  }

  static async setDefault({ id, propertyId, subpropertyId}) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation STRIPEEXTERNALACCOUNT_SET_DEFAULT( $id: String! $propertyId: String! $subpropertyId: String!) {
          stripeExternalAccountSetDefault(id: $id, propertyId: $propertyId, subpropertyId: $subpropertyId ) {
            id
          }
        }
      `,

      variables: {
        id,
        propertyId,
        subpropertyId
      },
    });

    return response.data.propertyCreate;
  }


  static async destroy({ id, propertyId, subpropertyId}) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation STRIPEEXTERNALACCOUNT_DESTROY( $id: String! $propertyId: String! $subpropertyId: String!) {
          stripeExternalAccountDestroy(id: $id, propertyId: $propertyId, subpropertyId: $subpropertyId )
        }
      `,

      variables: {
        id,
        propertyId,
        subpropertyId
      },
    });

    return response.data.propertyCreate;
  }

}
